import React from 'react';
import { Bell } from 'lucide-react';

const ICON_STROKE = 2.4;

/**
 * ADS Notification Bell — single implementation for header + sidebar (Phase 2).
 * Badge count is driven by `unreadCount` from Layout (no DOM querySelector writes).
 */
const AdsNotificationBell = ({
  onClick,
  title,
  'aria-label': ariaLabel,
  variant = 'header',
  iconSize,
  className = '',
  unreadCount = 0,
}) => {
  const size = iconSize ?? (variant === 'sidebar' ? 22 : 20);
  const count = Math.max(0, Number(unreadCount) || 0);
  const badgeLabel = count > 99 ? '99+' : String(count);
  const classes = [
    'ads-notification-bell',
    'notification-bell',
    variant === 'sidebar' ? 'app-sidebar-notification-bell' : 'ads-notification-bell--header',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      title={title}
      aria-label={ariaLabel || title}
    >
      <Bell className="notification-bell-icon" size={size} strokeWidth={ICON_STROKE} aria-hidden />
      <div
        className={`notification-badge${count > 0 ? '' : ' hidden'}`}
        aria-hidden="true"
      >
        {badgeLabel}
      </div>
    </button>
  );
};

export default AdsNotificationBell;
